import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-99084e70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "animate send-friendship" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Añadir amigo/a", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Podrás mensajearte con los amigos que añadas.Introduce su email y le llegará una petición de amistad. Si el usuario no está registrado en la plataforma, se le enviará un email de invitación.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_9 = { class: "input-box" }

import main from '@/data/main.js'
import { ref } from 'vue'
import { Toast } from '@/interfaces/ToastInterface'
import { useToast } from '@/store/useToast'
import FriendshipService from '@/services/FriendshipService'
import { useAuth } from '@/store/useAuth'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddFriend',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const email = ref('')
const toast = useToast()
const friendshipService = new FriendshipService()
const store = useAuth()

const sendInvitation = async () => {
    if(!store.token) {
        return
    }
    if(email.value.length < 5) {
        toast.showToast("Email no válido", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }
    const response = await friendshipService.sendFriendshipRequest(store.token, email.value)
    toast.showToast(response.message, Toast.INFO)
    setTimeout(function () { toast.hideToast() }, 4000);
    email.value = ""
    emit('close')
}

const close = () => {
    email.value = ""
    emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "close",
        onClick: close
      }, [
        _createVNode(_component_v_icon, {
          name: "ri-close-circle-fill",
          fill: "lightcoral",
          scale: "1.5"
        })
      ]),
      _createElementVNode("img", {
        src: _unref(main).LOGO_URI,
        width: "256"
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          placeholder: "Introduce email",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
        }, null, 512), [
          [_vModelText, email.value]
        ]),
        _createElementVNode("button", { onClick: sendInvitation }, "Enviar petición")
      ])
    ])
  ]))
}
}

})